import { PersonDto } from '../../person/models/PersonDto'
import { TenantDto } from './TenantDto'

export type UserTenantMembershipDto = {
    tenantId: string
    roles: UserRoles[]
    tenant?: TenantDto
}

export type UserDto = {
    id: string
    email: string
    profilePicUrl?: string
    isActive: boolean
    memberships: UserTenantMembershipDto[]
    isProductAdmin: boolean
    activeTenantId?: string
    personId?: string
    person?: PersonDto
    doNotShowDataPrivacy?: boolean
    feedbackModeEnabled?: boolean
    name?: string
    createdAt?: string
}

export enum UserRoles {
    TA = 'TA',
    HM = 'HM',
    JOB_SEEKER = 'JOB_SEEKER',
}
